import { useEffect, useCallback } from 'react';

interface ShortcutHandlers {
  onQuickCapture?: () => void;
}

export const useGlobalShortcuts = (handlers: ShortcutHandlers) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      // Cmd/Ctrl + J for Quick Capture
      if ((event.metaKey || event.ctrlKey) && event.key === 'j') {
        event.preventDefault();
        handlers.onQuickCapture?.();
      }
    },
    [handlers]
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);
};

export default useGlobalShortcuts;
